<template>
  <div class="page-bind">
    <div class="bind-title">绑定您的手机号</div>
    <div class="input-content">
      <div class="input-row">
        <div class="input-title">
          +86 <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div class="input-flex">
          <input v-model="phone" placeholder="请输入您的手机号" />
        </div>
      </div>
      <div class="input-row">
        <div class="input-title">
          验证码
        </div>
        <div class="input-flex">
          <input v-model="code" maxlength="4"  placeholder="请输入您的验证码" />
        </div>
        <button class="code-button"
             @click="obtainCode"
             style="color: #14CC80"
             :disabled="disabledSend">{{sendCode}}
        </button>
      </div>
    </div>
    <!-- <van-cell-group>

      <van-field v-model="phone"
                 label=""
                 label-width="58"
                 placeholder="手机号"
                 clearable
                 :error-message="errorMessage"
                 style="font-size: 0.3rem">

        <div slot="label"
             @click="obtainCode"
             style="display: flex">
          +86 <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </van-field>

      <van-field v-model="code"
                 label=""
                 label-width="10"
                 center
                 clearable
                 placeholder="验证码"
                 style="font-size: 0.3rem">

        <div slot="button"
             @click="obtainCode"
             style="color: #14CC80"
             :disabled="disabledSend">{{sendCode}}
        </div>

      </van-field>
    </van-cell-group> -->
    <div style="margin:0.4rem 0.4rem">
      <pi-button type="primary"
                 @click="bindPhone"
                 block>登录</pi-button>
    </div>
    <!-- <div class="button1"
         @click="bindPhone">
      绑定
    </div> -->
  </div>

</template>

<script>
import { getSmsCode, bindUser } from "../../../common/api";
import Vue from "vue";
import preventBack from "../../../common/forbidback";
import wxQrcode from '@/components/pi-wx-qrcode/pi-wx-qrcode.js'
import { CellGroup, Button, Field, Toast } from "vant";

export default {
  mixins: [preventBack], //注入禁止返回上一页
  components: {
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Field.name]: Field
  },
  data() {
    return {
      sendCode: "获取验证码",
      phone: "",
      code: "",
      errorMessage: "",
      time: 60,
      disabledSend: false,
      userImg: require("../../../assets/img/ic_bing_user.png"),
      userCode: require("../../../assets/img/ic_bing_code.png"),
      oprPkId: this.$common.query("oprPkId")
    };
  },

  created() {},
  watch: {},
  computed: {},
  mounted() {
    console.log(this.oprPkId);
  },
  methods: {
    timeDown() {
      let result = setInterval(() => {
        --this.time;
        this.sendCode = this.time + "s";
        if (this.time < 0) {
          clearInterval(result);
          this.disabledSend = false;
          this.sendCode = "获取验证码";
          this.time = 60;
        }
      }, 1000);
    },
    obtainCode() {
      if (this.phone.length <= 0) {
        this.$toast("手机号不能为空！");
        return;
      }

      if (!/^[1][3456789][0-9]{9}$/.test(this.phone)) {
        this.$toast("手机号格式不正确");
        return;
      }
      if (this.disabledSend) {
        return;
      }
      this.disabledSend = true;
      getSmsCode({
        oprPkId: this.oprPkId,
        phoneNo: this.phone,
        bussType: this.$config.bussType.login
      })
        .then(data => {
          console.log(data);
          if (data.status === this.$config.ajaxStatus) {
            this.$toast("验证码发送成功");
            this.disabledSend = true;
            this.timeDown();
          } else {
            console.log(data.msg);
            this.$toast(data.msg);
            this.disabledSend = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.$toast("验证码发送失败");
          this.disabledSend = false;
        });
    },
    bindPhone() {
      if (this.phone.length <= 0) {
        this.$toast("手机号不能为空！");
        return;
      }
      if (!/^[1][3456789][0-9]{9}$/.test(this.phone)) {
        Toast("手机号格式不正确");
        return;
      }
      if (!this.code) {
        Toast("请输入验证码");
        return;
      }
      let json = {
        phoneCode: this.code,
        phoneNo: this.phone,
        userPkId: this.$common.query("userPkId"),
        oprPkId: this.oprPkId
      };
      let inviter = this.$common.get('inviter');
      if(inviter && inviter !=''){
        json.inviter = inviter;
        this.$common.remove('inviter');
      }
      bindUser(json)
        .then(data => {
          console.log(data);
          if (data.status === this.$config.ajaxStatus && data.data[0]) {
            let userData = data.data[0]
            
            if(userData.hasSubscribe == 0){
              //新用户未关注
              this.openWxQrcode(userData.userPkId)
            }else{
              this.$common.save("token", userData.accessToken);
              this.$common.save("phone", this.phone);
              this.$common.save("oprPkId", this.oprPkId);
              this.$common.save("userInfo", userData);
              this.$store.commit("SET_USERINFO", userData);
              Vue.prototype.$oprPkId = this.oprPkId;

              this.$common.remove(this.$config.localKeyLogin.homeShowListStatus);
              this.$router.replace({ name: "home2" });
            }
            
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openWxQrcode(userPkId){
      wxQrcode({oprPkId :this.oprPkId,userPkId: userPkId});
    },
  }
};
</script>

<style lang="less" scoped>
.page-bind{
  min-height: 100%;
  display: flex;
  flex-direction:column;
}
.bind-title {
  font-size: 0.36rem;
  line-height: 0.5rem;
  color: #373A44;
  padding: 0.2rem;
}
.input-content{
    padding: 0.03rem 0.4rem ;
    flex: 1;
    .input-row{
      padding: 0.59rem 0 0.1rem 0;
      display: flex;
      border-bottom: 1px solid #DDDDDD;
      .input-title{
        font-size: 0.34rem;
        line-height: 0.48rem;
        color: #333;
        width: 1.23rem;
      }
      .input-flex{
        flex: 1;
        padding-left: 0.2rem;
        input{
          font-size: 0.34rem;
          width: 100%;
          height: 0.48rem;
          border: none;
          background: transparent;
        }
      }
      .code-button{
        background: transparent;
        border: none;
        color: #14CC80;
        font-size: 0.34rem;
      }
    }
  }
</style>
<style>
</style>
